import { useEffect, useState } from "react";
import { ArrowUp } from "lucide-react";

export default function BackToTop() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 250);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  if (!visible) return null;

  return (
    <button
      onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
      data-testid="back-to-top"
      aria-label="Retour en haut"
      className="fixed bottom-20 md:bottom-6 right-6 z-40 w-12 h-12 rounded-full bg-[#1B5E20] hover:bg-[#164d1a] text-white shadow-2xl shadow-[#1B5E20]/30 flex items-center justify-center transition-all hover:-translate-y-1 animate-fade-up"
    >
      <ArrowUp className="w-5 h-5" />
    </button>
  );
}
